
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/kol-profile/[leader]",
      function () {
        return require("private-next-pages/share/kol-profile/[leader].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/kol-profile/[leader]"])
      });
    }
  